<script setup lang="ts">
import { computed } from "vue";
type Tone = "neutral" | "brand" | "accent" | "success" | "warning" | "danger" | "info";
const props = withDefaults(defineProps<{ tone?: Tone; solid?: boolean }>(), { tone: "neutral" });
const cls = computed(() => [
  "cw-badge",
  props.solid ? "cw-badge--solid" : `cw-badge--${props.tone}`,
]);
</script>
<template><span :class="cls"><slot /></span></template>
